/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a function, not a React component. */
export function formatPaginationRangeText({
  pageIndex,
  pageSize,
  rowCount,
  totalCount,
}: {
  pageIndex: number;
  pageSize: number;
  rowCount: number | undefined;
  totalCount: number | undefined;
}): string {
  const start = pageIndex * pageSize + 1;
  const end = start + (rowCount ?? 0) - 1;
  const totalSuffix = totalCount !== undefined ? ` of ${totalCount.toLocaleString()}` : '';
  return rowCount === 0
    ? `Showing 0${totalSuffix} rows`
    : `Showing ${start}–${end}${totalSuffix} rows`;
}
